import { useRef, useState } from "react";
import { cn } from "@/lib/utils";

interface CompletedCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export function CompletedCheckbox({ checked = false, onChange }: CompletedCheckboxProps) {
    const [hasInteracted, setHasInteracted] = useState(false);
    const previousChecked = useRef(checked);

    const handleChange = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        setHasInteracted(true);
        const newChecked = !checked;
        onChange(newChecked);
    };

    // Update the ref when checked changes
    if (previousChecked.current !== checked) {
        previousChecked.current = checked;
    }

    return (
        <button
            type="button"
            onClick={handleChange}
            className={cn("block relative size-4 rounded-sm border scale-100 flex-shrink-0", {
                // Only apply transitions and animations after user interaction
                "transition-all duration-200 ease-in-out": hasInteracted,
                "bg-emerald-500 border-emerald-500": checked,
                "animate-checkbox-wave": checked && hasInteracted,
                "border-gray-400 hover:border-emerald-500 hover:bg-white": !checked,
            })}
        >
            <svg
                width="12px"
                height="10px"
                className={cn("absolute top-[2px] left-[0.5px] fill-none stroke-white stroke-2", {
                    // Only apply transitions after user interaction
                    "transition-all duration-300 ease-in-out delay-100": hasInteracted,
                })}
                style={{
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeDasharray: "16px",
                    strokeDashoffset: checked ? "0" : "16px",
                }}
                aria-hidden="true"
            >
                <polyline points="3 5 5 8 10 2"></polyline>
            </svg>
        </button>
    );
}
